export const izjava5Lookup =
    [
        {
            id: "1",
            ime: "Со оваа апликација потврдувам дека сум доволно информиран за правилата за контрола и сертификација на органско производство и располагам со капацитети истите да ги применувам во случај на склучување на договор за сертификација."
        }
    ]